// extracted by mini-css-extract-plugin
export default {"menu":"MobileMenu_menu__77xwj","open":"MobileMenu_open__e-I+E","secondLevel":"MobileMenu_secondLevel__8g7eP"};